import { render, staticRenderFns } from "./CreateCustomerPrices.vue?vue&type=template&id=1181862f"
import script from "./CreateCustomerPrices.vue?vue&type=script&lang=js"
export * from "./CreateCustomerPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports